import React from 'react';
import { RocketLaunchIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import { Link } from 'react-router-dom';

const FeedbackCultureFinalThoughts = () => {
  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Final Thoughts"
        icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
        heading
      >
        <PlaybookCard>
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-4">
              Using this guide offers you a comprehensive framework for initiating, establishing, and sustaining a feedback culture within a startup environment.
            </p>
          
           
          </div>
        </PlaybookCard>
      </PlaybookSection>
    </div>
  );
};

export default FeedbackCultureFinalThoughts; 